// Zacatek kontroly vyher
import {
    madnes_get_cstm_val, madnes_get_pos_y, madnes_set_alpha,
    madnes_set_cstm_val,
    madnes_set_pos, madnes_set_pos_y, madnes_set_texture,
    madnes_set_visible,
    madnes_sprite_get_frame_name, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";

import * as MV from "../framework/src/engine/madnes/madnes_variables";

import {
    freespins,
    states,
    server_config,
    server_result,
    behavior_config,
    inbigwin,
    inmoneyadd,
    inanim,
    in_free_spins,
    in_free_spins_pos,
    picture_convert, set_inanim, fps, ico_he
} from "../framework/src/engine/madnes/madnes_variables";

import {cylinder_pos, icons, smybols_offset_top} from "./ps_config";
import {get_orig_texture_name} from "./ps_core";
import {
    madnes_audio_fade_to,
    madnes_audio_loop,
    madnes_audio_pause, madnes_audio_play, madnes_audio_stop,
    madnes_set_audio_volume
} from "../framework/src/engine/madnes/madnes_audio";
import {ctrl_end_round_freespins, money_add_control} from "./ps_end_ctrl";
import {
    change_bar,
    change_multiplier,
    CounterAdd,
    fadein_all_reel_bonus,
    fadeout_all_reel_bonus,
    set_multiplier
} from "./ps_anims";
import {
    win,
    bet,
    madnes_win_anim_skip,
    madnes_set_win,
    madnes_add_win,
    madnes_is_in_freespins, madnes_get_fs_count, madnes_end_round, madnes_win_anim_reset, madnes_start_freespins
} from "../framework/src/engine/madnes/madnes";
import {madnes_loader_completed} from "../framework/src/engine/madnes/madnes_loader";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_alpha_to, madnes_move_to} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete,
    madnes_anim_add_oncomplete_once,
    madnes_anim_play, madnes_anim_stop
} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {mystery_start} from "./ps_mystery";
import AddResult from "../framework/src/connect/result/AddResult";
import {set_rotated} from "../framework/src/engine/madnes/madnes_variables";
import {set_in_free_spins} from "../framework/src/engine/madnes/madnes_variables";
import {STATES} from "../framework/src/states/states";
import {set_server_result} from "../framework/src/engine/madnes/madnes_variables";

export let result_control_pos = 0;
// var spin_win = 0;
var mystery_win = false;

export function inc_result_control_pos() {
    result_control_pos++;
}

export function result_control() {
    if(inmoneyadd || inbigwin)
    {
        setTimeout(result_control, 100);
        return;
    }

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var spos = 0; spos <= 2; spos++) {

            var spriteName = "reels_bufer_" + i + "_S" + ( 2 - spos );
            var spriteTextureName = get_orig_texture_name(madnes_sprite_get_frame_name(spriteName));
            madnes_set_texture(spriteName, "symbols_atlas");
            madnes_sprite_set_frame_name(spriteName, spriteTextureName);
        }
    }

    // spin_win = 0;
    set_inanim(1);
    result_control_pos = 0;

    toRun = [];
    fly_reel_pos = 0;
    tetris_pos = 0;
    symbol_count = [];

    mystery_win = false;

    result_control_part();
}

// kontrola vyhry na aktualni pozici
export async function result_control_part()
{
    var lw = server_result.result.lineWins;

    //debugger;
    if(lw == null || lw[result_control_pos] == null)
    {
        madnes_win_anim_reset();

        if(in_free_spins)
        {
            control_freespins();
        }
        else
        {
            madnes_audio_fade_to("BACKGROUND", behavior_config.sound.background.background, 1000);

            change_bar("logo");
            money_add_control();
        }

        return;
    }
    else
    {
        states.setState(STATES.SKIP);

        // madnes_hide_stop();

        if(madnes_win_anim_skip() && (
            lw[result_control_pos]['type'] === "wild" ||
            lw[result_control_pos]['type'] === "normal"
        ))
        {
            var win_set = lw[result_control_pos];
            await add_line_win(win_set);

            result_control_pos++;

            for(var pos in win_set['position']) {
                add_to_run(win_set['position'][pos]);
            }

            result_control_part();

        } else {
            result_control_part_proc(lw[result_control_pos]);
        }
    }
}

var symbol_count = [];

export let fs_start_sound = "BACKGROUND";

// kontrola aktualni vyhry
function result_control_part_proc(win_set)
{
    var linenum = 0;
    if(win_set['line'] != null && typeof win_set['line'] != "undefined" && win_set['line'] >= 0)
    {
        linenum = win_set['line'] + 1;
    }

    if(linenum != 0 || win_set['type'] == "tetris" || win_set['type'] == "mystery")
    {
        if(in_free_spins) {
            madnes_audio_fade_to(fs_start_sound, behavior_config.sound.background.freeSpinsBackground * 0.5, 1000);
        } else {
            madnes_audio_fade_to("BACKGROUND", behavior_config.sound.background.background * 0.5, 1000);
        }

        // madnes_win_anim_add();

        if(typeof win_set['symbol'] !== 'undefined') {
            play_winline_sound(picture_convert[win_set['symbol']], win_set['position'].length);
        }


        result_control_part_proc_trn(win_set);
    }
    else if(win_set['type'] == "scatter")
    {
        madnes_start_freespins();

        var waitFor = [];
        var fsResult = server_result;

        let fsCurrent = MV.freespins.getFreeSpinNumber();

        MV.game.freespins.run(new AddResult(server_result));

        let fsTotal = MV.freespins.getFreeSpinNumber();

        // console.log(fsCurrent, fsTotal);
        // console.log(MV.game.freespins);
        // debugger;

        if(!in_free_spins)
        {
            set_in_free_spins(true);

            if(madnes_loader_completed('fs_audio_bg')) //if is fs bg sound loaded
            {
                madnes_audio_pause("BACKGROUND");
                fs_start_sound = "BACKGROUND_FS";
            }
            else
            {
                fs_start_sound = "BACKGROUND";
            }

            madnes_set_audio_volume(fs_start_sound, behavior_config.sound.background.freeSpinsBackground * 0.5);
            madnes_audio_loop(fs_start_sound);

            setTimeout(function() {
                madnes_audio_fade_to(fs_start_sound, behavior_config.sound.background.freeSpinsBackground, 500);
            }, 800);


            // in_free_spins = true;
            // in_free_spins_pos = 0;
            // var cookieFsIdx = madnes_get_cookie(cname);

            // console.log(MV.game.freespins.stored());

            if(MV.game.freespins.isSkipping()) {
                // console.log(fsResult['result']['win'], fsResult);
                // if(typeof fsResult['result']['win'] !== 'undefined') {
                //     madnes_set_win(fsResult['result']['win']);
                // }

                madnes_set_win(MV.game.freespins.getResultWin());

                waitFor.push(fadein_all_reel_bonus("scatter"));

                Promise.all(waitFor).then(function() {
                    control_freespins(true);
                });

                return;
            }

            waitFor.push(change_bar("fs"));
        }

        waitFor.push(fadein_all_reel_bonus("scatter"));
        waitFor.push(fadein_black_screen());

        //madnes_set_audio_volume();

        play_winline_sound(picture_convert[win_set['symbol']], win_set['position'].length, true);

        var anims = [];

        for(var posX in win_set['position']) {

            var pX = win_set['position'][posX][0];
            var pY = win_set['position'][posX][1];
            var realPY = 2 - pY;

            var a = new Promise(function(res) {

                var spriteName = "reels_bufer_" + pX + "_S" + realPY;
                var spriteTmpName = "reels_bufer_" + pX + "_TMP" + realPY;
                //var text = "symbol_Scatter"; //get_orig_texture_name(madnes_get_texture(spriteName));

                madnes_set_texture(spriteTmpName, "symbol_Scatter_sheet_json");
                madnes_set_pos_y(spriteTmpName, madnes_get_pos_y(spriteName));

                madnes_set_visible(spriteName, false);
                madnes_set_visible(spriteTmpName, true);
                //madnes_set_pos_y(spriteName, -9999);

                madnes_anim_add(spriteTmpName, "anim", icons["symbol_Scatter"]["anim"]);
                madnes_anim_add_oncomplete_once(spriteTmpName, res);

                madnes_anim_play(spriteTmpName, "anim", 30);

            });

            anims.push(a);
        }

        var animated = Promise.all(anims).then(function() {

            return fadeout_black_screen().then(function() {

                for(var posX in win_set['position']) {
                    var pX = win_set['position'][posX][0];
                    var pY = win_set['position'][posX][1];
                    var realPY = 2 - pY;

                    var spriteName = "reels_bufer_" + pX + "_S" + realPY;
                    var spriteTmpName = "reels_bufer_" + pX + "_TMP" + realPY;

                    madnes_set_visible(spriteTmpName, false);
                    madnes_set_visible(spriteName, true);
                }

            });
        });

        var added = Promise.all(waitFor).then(function() {

            return add_free_spins(fsCurrent, fsTotal);

        }).then(function() {
            //in_free_spins_total = fsResult['result']['freeSpinNumber'];
        });

        Promise.all([animated, added]).then(function() {
            control_freespins();
        });
    }
    else
    {
        if(madnes_is_in_freespins()) {
            control_freespins();
        } else {
            result_control_pos++;
            result_control_part();
        }
    }
}

// Vstup do freespinu + animace pridani spinu
function add_free_spins(fsCurrent, fsTotal)
{
    return new Promise(function(res) {

        if(fsCurrent * 1 === fsTotal * 1) {
            res();
            return;
        }

        var fsCounter = new CounterAdd();
        fsCounter.onComplete(function() {
            //in_free_spins_total = fsTotal;
            //setTimeout(control_freespins, 800);
            res();
        });

        var add = 0;

        fsCounter.onUpdate(function() {
            madnes_audio_play("fs_counter");
            //fsTotal++;

            add++;
            madnes_set_text("fs_count", freespins.getRoundNumber() + "/" + (fsCurrent + add));
        });

        fsCounter.run(fsCurrent, fsTotal, 120);
    });
}

/**
 * @param {boolean=} fromSkip
 */
async function control_freespins(fromSkip)
{
    var fsResults = server_result['result']['freeSpinResults'];

    // var fs_win = 0; //spin_win;
    // var fs_count = madnes_get_fs_count();
    // var fs_order = in_free_spins_pos;

    let pos = MV.game.freespins.getRoundIndex() + 1;
    // console.log(pos);

    //spin_win = 0;

    if(fsResults[pos] == null || typeof fsResults[pos] == "undefined")
    {
        set_in_free_spins(false);

        // madnes_end_freespins();

        if(fs_start_sound === "BACKGROUND")
        {
            madnes_audio_fade_to("BACKGROUND", behavior_config.sound.background.background, 500);
        }
        else
        {
            madnes_audio_fade_to("BACKGROUND_FS", 0, 500, function() {
                madnes_audio_stop("BACKGROUND_FS");

            });
        }

        madnes_audio_loop("BACKGROUND");
        madnes_audio_fade_to("BACKGROUND", behavior_config.sound.background.background * 0.5, 500);

        fadeout_all_reel_bonus('scatter');

        change_bar("logo");

        ctrl_end_round_freespins().then(madnes_end_round);
    }
    else
    {
        change_bar("fs");

        madnes_audio_fade_to(fs_start_sound, behavior_config.sound.background.freeSpinsBackground, 500);

        set_rotated(false); //rotated = 0;

        let server_result_tmp = JSON.parse(JSON.stringify(server_result));

        let num = MV.game.freespins.getFreeSpinNumber();
        let pos = MV.game.freespins.getRoundIndex() + 1;
        // let idx = MV.game.freespins.getRoundIndex();

        await madnes_end_round();

        setTimeout(() => {

            set_server_result(server_result_tmp);
            server_result.result.reelMatrix = fsResults[pos].result.reelMatrix;
            server_result.result.freeSpinNumber = fsResults[pos].result.freeSpinNumber;
            server_result.result.lineWins = fsResults[pos].result.lineWins;
            server_result.result.gameSpecifics = fsResults[pos].result.gameSpecifics;
        }, 500);

        madnes_set_text("fs_count", (pos + 1) + "/" + num);
    }
}

async function add_line_win(win_set) {

    // console.log(win, win_set.win);

    if(win_set['win']) {
        await madnes_add_win(win_set['win'] * 1);

        // if(in_free_spins) {
        //     MV.game.freespins.setWin(win_set['win'] * 1);
        // }
    }
}

function setMultiplier(win_set) {
    if(win_set['multiplier'] && win_set['multiplier'] > 1) {

        if(madnes_get_cstm_val("multiplier_group")['hided'])
        {
            set_multiplier(win_set['multiplier']);
            change_bar("multi");
        }
        else
        {
            change_multiplier(win_set['multiplier']);
        }
    }
}

var toRun = [];
var fly_reel_pos = 0;
var tetris_pos = 0;

function result_control_part_proc_trn(win_set)
{
    if(win_set['type'] == "tetris")
    {
        if(tetris_pos == 0)
        {
            madnes_win_anim_reset();

            var posXSoundsPlayed = {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false
            };

            //toRunSymbsX = {};
            //add_to_run([0, 2]);
            //add_to_run([0, 1]);
            //add_to_run([0, 0]);

            var j = 0;

            var anims = [];

            for(var posX in toRunSymbsX)
            {
                var symbolsToRun = get_from_to_run(posX);

                for(var i = 0; i < symbolsToRun.length; i++) {
                    j++;

                    var symToRunX = symbolsToRun[i][0];
                    var symToRunY = 2 - symbolsToRun[i][1];

                    var symbName = "reels_bufer_" + symToRunX + "_S" + symToRunY;
                    var symbNameTmp = "reels_bufer_" + symToRunX + "_TMP" + symToRunY;

                    var symbol = get_orig_texture_name(madnes_sprite_get_frame_name(symbName));

                    madnes_set_pos_y(symbNameTmp, madnes_get_pos_y(symbName));
                    madnes_set_visible(symbNameTmp, true);

                    madnes_set_texture(symbNameTmp, "symbols_atlas");
                    madnes_sprite_set_frame_name(symbNameTmp, symbol);
                    madnes_set_visible(symbName, false);
                    madnes_set_cstm_val(symbName, 'flew');

                    (function(snt, sym, symPosX, symToRunY) {

                        var anim = new Promise(function(res) {

                            setTimeout(function() {

                                madnes_set_texture(snt, sym + "_touchdown_json");
                                madnes_anim_add(snt, "fly", icons[sym]["flyout"]);
                                madnes_anim_play(snt, "fly", 25);


                                madnes_tween_to(snt, { "y": (symToRunY + 1) * ico_he * -1 }, {
                                    'delay': 120,
                                    'duration': 240,
                                    'callback': function() {
                                        madnes_anim_stop(snt);
                                        madnes_set_pos_y(snt, -9999);
                                        madnes_set_visible(snt, false);
                                        res();
                                    }
                                });

                                if(!posXSoundsPlayed[symPosX]) {
                                    madnes_audio_play("fly_" + ( symPosX * 1 + 1 ));
                                    posXSoundsPlayed[symPosX] = true;
                                }

                            }, 200 * symPosX);
                        });

                        anims.push(anim);

                    }(symbNameTmp, symbol, posX, symToRunY));
                }
            }

            tetris_pos++;

            Promise.all(anims).then(function() {
                result_control_part_proc_trn(win_set);
            });

            return;
        }
        else if(tetris_pos == 1)
        {
            var bh = behavior_config.reel.brake.brakeHeight;
            var mbt = behavior_config.reel.brake.moveBackTime;
            var mt = behavior_config.reel.brake.moveTime;
            //var symbolsToShift = {};

            var posXSoundsPlayed = {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
            };

            for(var posX in toRunSymbsX) {

                for(var j = 2; j >= 0; j--) {
                    var newSymbolBuf = "reels_bufer_" + posX + "_S" + (2 - j);
                    madnes_set_texture(newSymbolBuf, "symbols_atlas");
                    madnes_sprite_set_frame_name(newSymbolBuf, picture_convert[server_result.result.reelMatrix[fly_reel_pos * 1 + 1][posX][j]]);
                }
            }

            new Promise(function(res) {

                var proms = [];

                for(var i = 0; i < cylinder_pos.length; i++) {

                    var calcShift = new CalcShift();

                    for(var j = 2; j >= 0; j--) {
                        calcShift.setSymbol("reels_bufer_" + i + "_S" + (2 - j));
                    }

                    calcShift.calc();

                    var shiftedSymbols = calcShift.getShiftedSymbols();

                    for(var k = 0, l = shiftedSymbols.length; k < l; k++) {

                        var prom = new Promise(function(resolve) {

                            var symbol = shiftedSymbols[k]['symbol'];
                            var symbolKey = get_orig_texture_name(madnes_sprite_get_frame_name(shiftedSymbols[k]['symbol']));

                            //madnes_sprite_set_frame(symbol, 8);

                            var posTo = madnes_get_pos_y(symbol);
                            var shift = shiftedSymbols[k]['shift']; //per symbol

                            var shiftLength = shift * ico_he;

                            var posFrom = posTo - shiftLength;

                            if(posFrom < smybols_offset_top) {
                                madnes_sprite_set_frame_name(symbol, symbolKey + "_blur");
                            } else {
                                madnes_sprite_set_frame_name(symbol, symbolKey);
                            }

                            madnes_set_pos_y(symbol, posFrom);

                            (function(symb, symbKey, posTo, symPosX, s) {

                                setTimeout(function() {

                                    madnes_set_texture(symb, symbKey + "_touchdown_json");
                                    madnes_anim_add(symb, "land2", icons[symbKey]["touchdown"]);
                                    madnes_anim_add_oncomplete_once(symb, function() {
                                        madnes_set_texture(symb, "symbols_atlas");
                                        madnes_sprite_set_frame_name(symb, symbKey);
                                        resolve();
                                    });

                                    var cs = in_free_spins ? behavior_config.reel.spin.freeSpinSpeed : behavior_config.reel.spin.commonSpeed;
                                    var time = s * (1000 / cs);

                                    madnes_move_to(symb, null, posTo, time);

                                    setTimeout(function() {
                                        madnes_anim_play(symb, "land2", 24);
                                        if(!posXSoundsPlayed[symPosX]) {
                                            madnes_audio_play("reel_tetris_stop_" + ( symPosX * 1 + 1 ));
                                            posXSoundsPlayed[symPosX] = true;
                                        }
                                    }, time - time / 4);


                                }, 1000 / fps * (symPosX + 1) * 4);

                                //setTimeout(madnes_anim_play.bind(this, symb, "land2", 30), timeFrom);

                            } (symbol, symbolKey, posTo, i, shift));

                            proms.push(prom);
                        });
                    }

                    for(var j = 2; j >= 0; j--) {
                        madnes_set_cstm_val("reels_bufer_" + i + "_S" + (2 - j), "");
                    }
                }

                Promise.all(proms).then(res);

            }).then(function() {

                setTimeout(function() {
                    tetris_pos++;
                    result_control_part_proc_trn(win_set);
                }, 200);

            });
        }
        else if(tetris_pos == 2)
        {
            fly_reel_pos++;
            toRunSymbsX = {};
            tetris_pos = 0;

            result_control_part_proc_nxt(win_set);
        }
    }
    else if(win_set['type'] == "wild")
    {
        add_line_win(win_set);
        setMultiplier(win_set);

        fadein_black_screen();

        new Promise(function(res) {

            var j = 0;
            for(var posX in win_set['position'])
            {
                j++;
                var spriteName = "reels_bufer_" + win_set['position'][posX][0] + "_S" + ( 2 - win_set['position'][posX][1] );
                var spriteTmpName = "reels_bufer_" + win_set['position'][posX][0] + "_TMP" + ( 2 - win_set['position'][posX][1] );
                var toSymbolTextureName = picture_convert[win_set['symbol']];

                var key = get_orig_texture_name(madnes_sprite_get_frame_name(spriteName));

                var tmpTextureName = key + "_sheet" + "_json";
                var iconFrames = key;

                if(key == "symbol_Wild" && key != toSymbolTextureName) {
                    tmpTextureName = key + "_to_" + toSymbolTextureName + "_json";
                    iconFrames = key + "_to_" + toSymbolTextureName;
                }

                madnes_set_texture(spriteTmpName, tmpTextureName);
                madnes_set_pos_y(spriteTmpName, madnes_get_pos_y(spriteName));
                madnes_set_visible(spriteTmpName, true);
                madnes_anim_add(spriteTmpName, 'anim', icons[iconFrames]["anim"]);

                madnes_set_visible(spriteName, false);
                madnes_set_visible(spriteTmpName, true);

                (function(sprTmpName, sprName) {
                    madnes_anim_add_oncomplete_once(sprTmpName, function() {
//						madnes_set_visible(sprTmpName, false);
//						madnes_set_visible(sprName, true);

                        if(j === win_set['position'].length) {
                            res();
                        }

                    });

                    madnes_anim_play(sprTmpName, "anim", 25);

                }(spriteTmpName, spriteName));

                add_to_run(win_set['position'][posX]);
            }
        }).then(function() {

            return fadeout_black_screen();

        }).then(function() {

            for(var posX in win_set['position']) {
                var spriteName = "reels_bufer_" + win_set['position'][posX][0] + "_S" + ( 2 - win_set['position'][posX][1] )
                var spriteTmpName = "reels_bufer_" + win_set['position'][posX][0] + "_TMP" + ( 2 - win_set['position'][posX][1] );
                madnes_set_visible(spriteTmpName, false);
                madnes_set_visible(spriteName, true);
            }

            setTimeout(function() {
                result_control_part_proc_nxt(win_set);
            }, 300);
        });
    }
    else if(win_set['type'] == "normal")
    {
        //play_winline_sound(picture_convert[win_set.symbol], win_set['position'].length - 1);

        add_line_win(win_set);
        setMultiplier(win_set);

        fadein_black_screen();

        new Promise(function(res) {

            var j = 0;
            for(var posX in win_set['position']) {
                j++;
                var spriteName = "reels_bufer_" + win_set['position'][posX][0] + "_S" + ( 2 - win_set['position'][posX][1] )
                var spriteTmpName = "reels_bufer_" + win_set['position'][posX][0] + "_TMP" + ( 2 - win_set['position'][posX][1] );

                var text = get_orig_texture_name(madnes_sprite_get_frame_name(spriteName));

                madnes_set_texture(spriteTmpName, text + "_sheet_json");

                madnes_anim_add(spriteTmpName, 'anim', icons[text]["anim"]);
                madnes_set_pos_y(spriteTmpName, madnes_get_pos_y(spriteName));
                //madnes_set_pos_y(spriteName, -9999);
                madnes_set_visible(spriteName, false);
                madnes_set_visible(spriteTmpName, true);

                (function(sprTmpName, sprName, j) {
                    madnes_anim_add_oncomplete(sprTmpName, function() {
//						madnes_set_visible(sprTmpName, false);
//						madnes_set_visible(sprName, true);

                        if(j === win_set['position'].length) {
                            res();
                        }

                    });

                    madnes_anim_play(sprTmpName, "anim", 25);

                }(spriteTmpName, spriteName, j));

                add_to_run(win_set['position'][posX]);
            }

        }).then(function() {

            return fadeout_black_screen();

        }).then(function() {

            for(var posX in win_set['position']) {
                var spriteName = "reels_bufer_" + win_set['position'][posX][0] + "_S" + ( 2 - win_set['position'][posX][1] )
                var spriteTmpName = "reels_bufer_" + win_set['position'][posX][0] + "_TMP" + ( 2 - win_set['position'][posX][1] );
                madnes_set_visible(spriteTmpName, false);
                madnes_set_visible(spriteName, true);
            }

            setTimeout(function() {
                result_control_part_proc_nxt(win_set);
            }, 300);
        });
    }
    else if(win_set['type'] == "mystery")
    {
        mystery_win = true;

        fadein_all_reel_bonus('mystery');
        fadein_black_screen();

        var anims = [];

        for(var posX in win_set['position']) {

            var pX = win_set['position'][posX][0];
            var pY = win_set['position'][posX][1];
            var realPY = 2 - pY;

            var a = new Promise(function(res) {

                var spriteName = "reels_bufer_" + pX + "_S" + realPY;
                var spriteTmpName = "reels_bufer_" + pX + "_TMP" + realPY;

                var text = get_orig_texture_name(madnes_sprite_get_frame_name(spriteName));
                madnes_set_texture(spriteTmpName, text + "_sheet_json");

                madnes_anim_add(spriteTmpName, "anim", icons[text]["anim"]);
                madnes_anim_add_oncomplete_once(spriteTmpName, function() {
                    res();
                });

                madnes_set_pos_y(spriteTmpName, madnes_get_pos_y(spriteName));
                madnes_set_visible(spriteTmpName, true);
                madnes_set_visible(spriteName, false);

                madnes_anim_play(spriteTmpName, "anim", 30);

                add_to_run(win_set['position'][posX]);
            });

            anims.push(a);
        }

        Promise.all(anims).then(function() {

            setTimeout(function() {
                mystery_start(win_set);
            }, 300);
        });

    }
    else
    {
        result_control_part_proc_nxt(win_set);
    }
}

/**
 * @constructor
 * @returns {CalcShift}
 */
function CalcShift() {
    this.symbols = [];
}

CalcShift.prototype.setSymbol = function(symbol) {
    this.symbols.push({ 'symbol': symbol, 'shift': 0 });
};

CalcShift.prototype.getSymbols = function() {
    return this.symbols;
};

CalcShift.prototype.calc = function() {
    this.calcSymbol(0);
};

CalcShift.prototype.getShiftedSymbols = function()
{
    var symbs = [];
    for(var i = 0; i < this.symbols.length; i++) {
        if(this.symbols[i]['shift'] > 0) {
            symbs.push(this.symbols[i]);
        }
    }

    return symbs;
};

CalcShift.prototype.calcSymbol = function(index) {

    var fixedShift = false;
    var fShift = 0;

    while(typeof this.symbols[index] !== 'undefined') {
        var symbolName = this.symbols[index]['symbol'];
        var shift = 0;

        if(madnes_get_cstm_val(symbolName) != "flew" && madnes_get_cstm_val(symbolName) != "move") {
            shift = 0;
        } else {

            for(var i = index; i < this.symbols.length; i++) {
                var symbolTmpName = this.symbols[i]['symbol'];

                if(fixedShift) {
                    shift = fShift;
                    break;
                }

                if(madnes_get_cstm_val(symbolTmpName) == "flew" || madnes_get_cstm_val(symbolTmpName) == "move") {
                    shift++;
                } else {
                    madnes_set_cstm_val(symbolTmpName, "move");
                    break;
                }

                if(i === this.symbols.length - 1) {
                    fixedShift = true;
                    fShift = shift;
                }
            }
        }

        if(fixedShift) {
            this.symbols[index]['shift'] = fShift;
        } else {
            this.symbols[index]['shift'] = shift;
        }

        index++;
    }
};

var toRunSymbsX = {}; //symboly ktere v tetrisu "utecou"

/**
 * Vytvori pole obsahujici indexy symbolu, ktere "utecou"
 * @param {Array} winsetpos - souradnice x,y
 */
function add_to_run(winsetpos)
{
    var x = winsetpos[0];
    var y = winsetpos[1];

    if(typeof toRunSymbsX[x] == 'undefined') {
        toRunSymbsX[x] = {};
    }



    if(typeof toRunSymbsX[x][y] == 'undefined') {
        toRunSymbsX[x][y] = winsetpos;
    }
}

/**
 * Returns x,y symbols position, which have to "run" from reels
 * @param {string} posX
 * @returns {Array} [x, y]
 */
function get_from_to_run(posX) {
    var to_runs = [];

    if(typeof toRunSymbsX[posX] != 'undefined') {
        for(var posY in toRunSymbsX[posX]) {
            to_runs.push(toRunSymbsX[posX][posY]);
        }
    }

    return to_runs;
}

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
function result_control_part_proc_nxt(win_set)
{
    setTimeout(function() {
        result_control_pos++;
        result_control_part();
    }, 1000 / fps);
}

function show_black_screen()
{
    madnes_set_visible("black_screen_graphics", true);
    madnes_set_pos("black_screen_graphics", 0, 0);
    madnes_set_cstm_val("black_screen_graphics", false); //hided = false
}

export function hide_black_screen()
{
    madnes_set_pos("black_screen_graphics", -9999, -9999);
    madnes_set_visible("black_screen_graphics", false);
    madnes_set_cstm_val("black_screen_graphics", true); //hided = true
}

export function fadeout_black_screen()
{
    return new Promise(function(res) {
        if(!madnes_get_cstm_val("black_screen_graphics")) {

            madnes_set_cstm_val("black_screen_graphics", true);

            madnes_alpha_to("black_screen_graphics", 0, 180, function () {
                hide_black_screen();
                res();
            });
        }
        else
        {
            res();
        }

    });


}

function fadein_black_screen()
{
    return new Promise(function(res) {

        if(madnes_get_cstm_val("black_screen_graphics")) {

            show_black_screen();
            madnes_set_alpha("black_screen_graphics", 0);
            madnes_alpha_to("black_screen_graphics", 0.7, 300, res);
        }
        else
        {
            res();
        }
    });
}

/**
 * @param {string} symbol
 * @param {number} count
 * @param {boolean=} fromScatter
 */
function play_winline_sound(symbol, count, fromScatter) {
    if(!count || count < 3 || !madnes_loader_completed('win_symbols_audio')) {
        count = 3;
    }

    //console.log(symbol, count, fromScatter);

    if(fromScatter) {
        madnes_set_audio_volume("win_" + symbol + "_" + count, server_config["behavior"]["sound"]["volume"]["winAnim"] * 1);
    } else {
        madnes_set_audio_volume("win_" + symbol + "_" + count, server_config["behavior"]["sound"]["volume"]["winAnim"] * 1.15);
    }

    madnes_audio_play("win_" + symbol + "_" + count);
}